import { render } from "./AccountMoved.vue?vue&type=template&id=875bfb9a&scoped=true&ts=true&lang=pug"
import script from "./AccountMoved.vue?vue&type=script&lang=ts"
export * from "./AccountMoved.vue?vue&type=script&lang=ts"

import "./AccountMoved.vue?vue&type=style&index=0&id=875bfb9a&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./AccountMoved.vue?vue&type=custom&index=0&blockType=i18n&locale=en"
if (typeof block0 === 'function') block0(script)
import block1 from "@/locale/es/components/accountMoved.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Ftarball%2Fsrc%2Fviews%2FAccountMoved.vue&locale=es"
if (typeof block1 === 'function') block1(script)


import exportComponent from "/tarball/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-875bfb9a"]])

export default __exports__